import Router from 'next/router'

import { onTrafficLookupDesignReady, TRAFFIC_LOOKUP_VARIANTS } from '~/services/tracking/posthog'
import { DOCKET_BASE, LOOKUP_BASE, stripLocale } from '~/utilities/trafficLookupRoutes'

// Only the NY landing (/traffic/lookup) has a Docket twin; other states stay on control.
export const willRedirectToDocket = variant =>
  variant === TRAFFIC_LOOKUP_VARIANTS.test && stripLocale(window.location.pathname) === LOOKUP_BASE

export function redirectToDocketIfAssigned() {
  onTrafficLookupDesignReady(variant => {
    if (!willRedirectToDocket(variant)) return
    // Router keeps the active locale, so /es/traffic/lookup lands on /es/traffic/lookup/v2.
    Router.replace(`${DOCKET_BASE}${window.location.search}`)
  })
}

// Landing is tracked on the page the visitor stays on, not the one they bounce off.
export function trackLandingUnlessRedirecting(track) {
  onTrafficLookupDesignReady(variant => {
    if (willRedirectToDocket(variant)) return
    track()
  })
}
